import React from 'react';

export const ZenerSymbols = {
  circle: () => (
    <svg viewBox="0 0 100 100" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="35" fill="none" stroke="currentColor" strokeWidth="2.5" />
    </svg>
  ),
  
  cross: () => (
    <svg viewBox="0 0 100 100" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      {/* Plus symbol (+) instead of cross */}
      <line x1="50" y1="20" x2="50" y2="80" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <line x1="20" y1="50" x2="80" y2="50" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  ),
  
  plus: () => (
    <svg viewBox="0 0 100 100" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <line x1="50" y1="20" x2="50" y2="80" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <line x1="20" y1="50" x2="80" y2="50" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  ),
  
  waves: () => (
    <svg viewBox="0 0 100 100" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <path d="M 15 35 Q 25 25, 35 35 T 55 35 T 75 35 T 85 35" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M 15 50 Q 25 40, 35 50 T 55 50 T 75 50 T 85 50" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M 15 65 Q 25 55, 35 65 T 55 65 T 75 65 T 85 65" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
  
  square: () => (
    <svg viewBox="0 0 100 100" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <rect x="20" y="20" width="60" height="60" fill="none" stroke="currentColor" strokeWidth="2.5" />
    </svg>
  ),
  
  star: () => (
    <svg viewBox="0 0 100 100" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <path d="M 50 15 L 58 40 L 85 40 L 63 55 L 71 80 L 50 65 L 29 80 L 37 55 L 15 40 L 42 40 Z" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
    </svg>
  )
};

export const getSymbolComponent = (symbol) => {
  const symbolKey = symbol.toLowerCase();
  // Map 'cross' to 'plus' for display
  if (symbolKey === 'cross') {
    return ZenerSymbols.plus;
  }
  return ZenerSymbols[symbolKey] || ZenerSymbols.circle;
};
